import React from "react";
import { YhBox } from "@src/components/YhBox";
import { Button, Select, Tree } from "antd";
import { useMenuModel } from "../menuModel";
import { IMdMenuDetail } from "../MenuTypes";


export function TreeDict() {
  const {
    appCode,
    selectedRowKeys,
    appOptions,
    treeData,
    setSelectedMenuKeys,
    setAppCode,
    setActionType,
    setMenuOptMode,
    setSelectedMenu,
    setFormValues,
  } = useMenuModel()

  const onSelect = (selectedKeys: React.Key[], info: any) => {
    const selectedNode = info.selectedNodes[0];
    console.log(selectedKeys, selectedNode)
    // const pNode = dataSource.find(item => item.code === selectedNode?.pcode)
    // setSelectParentData(pNode)
    setSelectedMenu(selectedNode ?? {})
    setFormValues(selectedNode ?? {})
    setSelectedMenuKeys(selectedKeys)
    setMenuOptMode('detail')
  }

  /** 新增菜单 */
  const onAddMenu = () => {
    if (selectedRowKeys.length === 0) {
      setSelectedMenuKeys(['root']);
      setMenuOptMode("add_root")
    } else {
      setMenuOptMode("add")
    }
    setActionType('menu')
    setFormValues({})
  }

  /**
   * 选择app
   * @param code AppCode
   */
  const onSelectApp = (code: string) => {
    setAppCode(code)
    setSelectedMenuKeys([])
    setSelectedMenu({} as IMdMenuDetail)
    setFormValues({})
    setActionType('menu')
  }

  return (
    <YhBox
      action={
        <Select options={appOptions} onSelect={onSelectApp} value={appCode}></Select>
      }
      title="数据字典"
      width="400px"
      maxHeight="650px"
    >
      <div style={{ border: '1px solid #EBEBEC', margin: '0px 15px', padding: '20px' }}>
        <Button type="link" shape="round" onClick={onAddMenu}>新增</Button>
        <div style={{ overflowY: 'scroll', height: '550px', marginTop: '10px' }}>
          <Tree
            className="p-15"
            treeData={treeData}
            onSelect={onSelect}
            selectable={true}
            // selectedKeys={selectedRowKeys}
            titleRender={(nodeData: IMdMenuDetail) => nodeData.name as string}
          />
        </div>
      </div>
    </YhBox >
  );
}

